import React from 'react';
import styled from 'styled-components';
import { getThemeProp } from 'styles/theme';
import { colors } from '@omilia/theme';
import { useTranslation } from '@omilia/providers';

import logo from 'styles/encodedLogo';

const SFooterText = styled.div<{ isDefault?: boolean }>`
  align-items: ${({ isDefault }) => (isDefault ? 'initial' : 'center')};
  box-sizing: border-box;
  color: ${colors.COLOR_GREY_800};
  display: flex;
  font-family: ${getThemeProp('fontFamily')};
  font-size: 11px;
  justify-content: center;
  margin: 0 auto;
  padding: 0px 20px 12px 20px;
  text-align: center;
`;

const SLogo = styled.img`
  margin-left: 4px;
  width: 31px;
`;

const SLink = styled.a`
  text-decoration: none;
`;

const OMILIA_WEBSITE_LINK = 'https://omilia.com';

export const FooterText = ({ showFooter = false, text = '', logoURL = '' }) => {
  const { t } = useTranslation();

  if (showFooter && !text && !logoURL) {
    return (
      <SFooterText isDefault>
        <span>{t('footer.poweredBy')}</span>
        <SLink target="_blank" rel="noopener" href={OMILIA_WEBSITE_LINK}>
          <SLogo src={logo} alt="logo" />
        </SLink>
      </SFooterText>
    );
  } else if (showFooter) {
    return (
      <SFooterText>
        <span>{text}</span>
        {logoURL && <SLogo src={logoURL} alt="logo" />}
      </SFooterText>
    );
  }

  return null;
};
